<div class="sidepanel-container {{className}} {{currentPage ? 'currentPage' : ''}}">
  <div class="notes-legal-line {{isOnboardingDasboard ? 'font-sm px-2' : ''}}">
  <div class="block-desc">
      <p>Note: These notes are private and can only be viewed by Admins.</p>
  </div>
</div>
  <div class="block-title py-2">
    <h2>Notes</h2> <!-- {{userName}} -->
    <div class="close-box">
      <button type="button" class="modal-close-btn close ml-3" (click)="close(false)">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
          <rect width="28" height="28" rx="6" fill="none" />
          <g transform="translate(4 4)">
            <rect width="20" height="20" fill="none" />
            <path d="M10,11.229,5.979,15.25a.789.789,0,0,1-.6.24.863.863,0,0,1-.6-.261.88.88,0,0,1,0-1.229l4-4L4.75,5.979a.8.8,0,0,1-.24-.614.875.875,0,0,1,.261-.615A.88.88,0,0,1,6,4.75l4,4.021L14.021,4.75A.869.869,0,0,1,15.25,5.979L11.229,10l4.021,4.021a.855.855,0,0,1,0,1.208.88.88,0,0,1-1.229,0Z"
                  transform="translate(-0.005 0.005)" fill="#757575" />
          </g>
        </svg>
      </button>
    </div>
  </div>
  <div class="side-attachments">
      <div class="common-loader" >
      <div class="loader-icon" [hidden]="isDataFound">
        <img src="assets/images/common-loader.gif" alt="">
      </div>
    </div>
    <div class="sidepanel-table">        
      <div class="side-note-container" >
        <div class="notes-box" *ngFor="let notes of userInternalNotes"> <!-- *ngFor="let notes of licenseNotes" -->
          <div class="img-block">                
            <span title="{{notes.userNote}}">{{notes.userNote}}</span>
          </div>
          <div class="d-flex">
            <span class="time-note">{{notes.createdByName}}</span>
            <span class="seprator mx-1"></span>
            <span class="time-note">{{notes.createdOn | date: 'MM/dd/yyyy hh:mm a'}}</span>
          </div>
        </div>
      </div>
      <div class="no-data-found inside-attachment" *ngIf="isDataFound && (userInternalNotes == null || (userInternalNotes != null && userInternalNotes.length <= 0))">
        <img src="../../../../assets/images/no-data.svg">
        <h5>No notes here</h5>
        <div>Notes would be visible here</div>
      </div>


     

    </div>
    
    <div class="request-activity-container">
      <form class="group-form" [formGroup]="userInternalNoteForm">
        <div class="data-form">
          <div class="text-count">
            <textarea name="notes" autofocus maxlength="500" class="form-control" id="memo" cols="30" rows="10" placeholder="Add a note..." formControlName="memo"></textarea>
            <div class="notes-count">
              <p class="m-0">({{userInternalNoteForm.value.memo.length}}/500)</p>
              <a class="commn-btn" href="javascript:void()" [class.disabled]="!userInternalNoteForm.valid || !isMemoValid" (click)="insertUserInternalNote()">Add</a>
            </div>
          </div>
        </div>
      </form>
    </div>

 

  </div>
</div>

